module.exports = __webpack_public_path__ + "media/audio5.58b35b8e.mp3";